import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateToken } from 'src/api/api';
import { unavailableAccountsMessage, updateAccountTokens } from 'src/api/accountTokens';
import { dropUnavailableFcAccounts, setTokenRefreshStatus } from 'src/store/actions/loginAction';
import { useRootAppSelector } from 'src/store/hooks';
import { IRootReducer } from 'src/store/reducers';
import { loginSelector } from 'src/store/selectores/loginSelectors';
import { dropsDisplaySelectors } from 'src/store/slices/dropsDisplay/dropDisplaySlice';
import { asRootReducer } from 'src/store/utils';
import { IAccount, RefreshTokenStatus } from 'src/types/login';
import useGetApiRequestBasicParams from '../useGetApiRequestBasicParams';

type Props = {};

export const useRefreshToken = () => {
    const dispatch = useDispatch();

    const [isLoadingToken, setIsLoadingToken] = useState(false);

    const { t } = useTranslation();
    const { selectedFcAccount } = useSelector((state: IRootReducer) => loginSelector(state));

    const { dbUrl, token, proxyUrl, contactUUID } = useGetApiRequestBasicParams();

    const refreshToken = useCallback(async () => {
        if (!isLoadingToken && contactUUID && token && dbUrl) {
            setIsLoadingToken(true);

            const account = selectedFcAccount ?? ({ contactUUID } as IAccount);
            const { unavailable } = await updateAccountTokens([account], () =>
                updateToken({ token, proxyUrl, dbUrl, contactUUID })
            );

            setIsLoadingToken(false);
            if (unavailable.length) {
                dropUnavailableFcAccounts(unavailable, unavailableAccountsMessage(unavailable, t));
                return;
            }
            dispatch(setTokenRefreshStatus(RefreshTokenStatus.Ok));
        }
    }, [contactUUID, dbUrl, dispatch, isLoadingToken, proxyUrl, selectedFcAccount, t, token]);

    return { refreshToken, isLoadingToken };
};
